
const initialState = {}

// REDUCERS
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'loadData@shop': {
			return action.data
		}

		default: return state
	}
}
